import { Col, Row } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import FormList from '../../../../../../../components/form-list';
import CaseBlock from './CaseBlock';
import { SPAN_FULL, SPAN_ONE_THIRD } from '../../../../../../../styles/constants';
import { onChangeCaseFunction } from '../../actions';
import { getInitialCaseBlock } from '../../../utils';
import functionsData from '../../../../../../../config/functions.json';
import operatorsData from '../../../../../../../config/operators.json';
import { translate } from 'react-i18next';
import _ from "lodash";
import SelectEditable from '../SelectEditable';

const mapStateToProps = state => ({
    CaseComponentDefinition: state.scenes.dataManager.fileMapping.components.wizard.components.addField.CaseComponentDefinition,
    nameValue:state.scenes.dataManager.fileMapping.components.wizard.components.addField.FunctionFormData.nameValue,
    mergedHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.mergedHeader,
})


const mapDispatchToProps = dispatch => ({
    onChangeForm: (value) => dispatch(onChangeCaseFunction(value))
})


const FileMappingWizardCaseWizard = ({
    t,
    CaseComponentDefinition,
    onChangeForm,
    nameValue,
    mergedHeader
    }) => {

    const blockNumber = (CaseComponentDefinition.blocks || []).length
    const [componentDefault, setComponentDefault] = React.useState(null)

    const selectFunction = React.useMemo(()=> {
        const FunctionsDta = functionsData.Functions.filter(e => e.Name !== 'Concat' && e.Name !== 'Case' && e.Name !== 'File' && e.Name !== 'IIF' && e.Name)
        .map(e => e.Name)
        return _.concat(['Str func'], FunctionsDta)
    },[functionsData])

    const selectComponent = React.useMemo(()=>{
        return _.some(mergedHeader) ? mergedHeader.map(e => e.name) :  []
    },[mergedHeader])


    const selectOperators = React.useMemo(()=>{
        return operatorsData.Operators.map(e => !['AND', 'OR', '()'].includes(e.label) && e.label).filter(Boolean)
      },[operatorsData]) 
    

    return (
            <Col span={SPAN_FULL}>
            <Row type='flex'>
                <Col span={SPAN_FULL}>
                    <FormList
                        notCollapsable
                        values={CaseComponentDefinition.blocks}
                        Component={CaseBlock}
                        componentProps={{
                            componentConditions:CaseComponentDefinition.blocks,
                            selectFunction:selectFunction,
                            selectComponent:selectComponent,
                            selectOperators: selectOperators,
                            nameValue
                        }}
                        newItem={getInitialCaseBlock(blockNumber)}
                        addItemLabel={t('scenes.dataManager.fileMapping.wizard.addField.functions.case.label.addBlock')}
                        removeItemLabel={t('scenes.dataManager.fileMapping.wizard.addField.functions.case.label.removeBlock')}
                        onChange={values => onChangeForm({blocks:values})}                     
                    />
                </Col>
            </Row>
                <Row type='flex' align='middle'>
                        <Col span={SPAN_ONE_THIRD}>
                            <Row type="flex" align='middle' style={{justifyContent:'flex-start', gap:5}}>
                                <span style={{color:'red'}} >*</span>
                                <b>{t('scenes.dataManager.fileMapping.wizard.addField.functions.case.label.defaultValue')}</b> 
                            </Row>
                        
                        </Col>
                        <Col span={SPAN_ONE_THIRD}>
                            <Row type="flex" align='middle' style={{justifyContent:'center', gap:5, textTransform:'uppercase'}}>
                                <span>{!!nameValue ? `${nameValue}=` : t('scenes.dataManager.fileMapping.wizard.addField.functions.case.label.baseFor')}</span>
                                <SelectEditable 
                                    width={150}
                                    value={componentDefault}
                                    options={selectComponent}
                                    onValue={(value) => onChangeForm({defaultValue: value})}
                                />
                            </Row>
                        </Col>
                    </Row>
            </Col>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(FileMappingWizardCaseWizard)